import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputSelect, {
      name: "agrupamento",
      label: "Agrupamento",
      placeholder: "Selecione uma das opções",
      modelValue: _ctx.agrupamento,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agrupamento) = $event)),
      onChange: _ctx.onChange,
      required: _ctx.required,
      options: _ctx.agrupamentoFiltrado,
      disabled: _ctx.disabled
    }, null, 8 /* PROPS */, ["modelValue", "onChange", "required", "options", "disabled"])
  ]))
}